export default __webpack_public_path__ + "static/media/reg_territori.8e4ab6b0.pdf";